import { useState, useEffect } from 'react';
import { Property, AppUser } from '../types';
import { useAdminProperties } from './useAdminProperties';

export const usePropertyAdminOperations = (appUser: AppUser | null) => {
  const [overallPropertyAdminMessage, setOverallPropertyAdminMessage] = useState<string | null>(null);

  const {
    foundPropertyForAdmin,
    setFoundPropertyForAdmin,
    isLoadingSearch,
    propertyAdminMessage,
    searchPropertyAdmin,
    savePropertyAdmin,
    createPropertyManual,
  } = useAdminProperties(appUser);

  const [editingProperty, setEditingProperty] = useState<Property | null>(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [propertyAdminSearchCode, setPropertyAdminSearchCode] = useState('');

  const handleSearchPropertyAdmin = async () => {
    const message = await searchPropertyAdmin(propertyAdminSearchCode);
    setOverallPropertyAdminMessage(message);
  };

  const handleOpenPropertyEditModal = (property: Property) => setEditingProperty(property);
  const handleClosePropertyEditModal = () => setEditingProperty(null);

  const handleSaveProperty = async (updatedPropertyData: Partial<Property>) => {
    try {
      await savePropertyAdmin(updatedPropertyData);
      setOverallPropertyAdminMessage(`Propiedad ${updatedPropertyData.codigo} actualizada exitosamente.`);
      setFoundPropertyForAdmin((prev) => {
        if (!prev) return null;
        if (Array.isArray(prev)) {
          return prev.map((p) => (p.id === updatedPropertyData.id ? { ...p, ...updatedPropertyData } : p));
        }
        return { ...prev, ...updatedPropertyData };
      });
      handleClosePropertyEditModal();
    } catch (error: any) {
      setOverallPropertyAdminMessage(error.message);
    }
  };

  const handleCreateProperty = async (newProperty: Partial<Property>, imageFiles: File[] = []) => {
    try {
      await createPropertyManual(newProperty, imageFiles);
      setOverallPropertyAdminMessage(`Inmueble ${newProperty.codigo} creado exitosamente.`);
      setIsCreateModalOpen(false);
    } catch (error: any) {
      throw error;
    }
  };

  useEffect(() => {
    if (propertyAdminMessage) setOverallPropertyAdminMessage(propertyAdminMessage);
  }, [propertyAdminMessage]);

  return {
    overallPropertyAdminMessage,
    setOverallPropertyAdminMessage,
    propertyAdminSearchCode,
    setPropertyAdminSearchCode,
    foundPropertyForAdmin,
    editingProperty,
    isLoadingSearch,
    handleSearchPropertyAdmin,
    handleSaveProperty,
    handleOpenPropertyEditModal,
    handleClosePropertyEditModal,
    isCreateModalOpen,
    setIsCreateModalOpen,
    handleCreateProperty,
  };
};
